import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Widget } from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import './modal.css';
import { acatarSubstituicao } from '@app/api/autorizacaoPagamento/autorizacao';

export interface propsModalAcatar {
  arquivoAutorizacaoId: string;
  setUpdate: any;
}

const ModalAcatarSubstituicao = (props: propsModalAcatar) => {
  const { arquivoAutorizacaoId, setUpdate } = props;
  const [exibirModal, setExibirModal] = useState(false);

  const handleSubmit = values => {
    acatarSubstituicao(arquivoAutorizacaoId, values.justificativa).then(data => {
      if (data) {
        setExibirModal(false);
        setUpdate(null);
        setUpdate(true);
      }
    });
  };

  return (
    <>
      <Tooltip title="Acatar">
        <Button
          onClick={() => {
            setExibirModal(true);
            // CarregarDados();
          }}
          icon="ui-checked"
          name="btnAcatar"
        />
      </Tooltip>
      <Modal
        title="Acatar"
        // className="chat-modal"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formModal"
          onSubmit={handleSubmit}
          actions={[
            <Button
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton
              noIcon={true}
              type="primary"
              disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR'])}>
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <FormTextArea name="justificativa" label="Justificativa" span={12} rows={4} maxLength={2000} />
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};
export default ModalAcatarSubstituicao;
